import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export function getAccessNavigationRedirect(
  location: Pick<Location, 'pathname' | 'search' | 'hash'>,
): string | undefined {
  const { pathname, search, hash } = location;

  if (pathname === '/access') {
    return `/access/bindings${search}${hash}`;
  }

  if (pathname === '/rbac' || pathname.startsWith('/rbac/')) {
    return `${pathname.replace(
      /^\/rbac(?=\/|$)/,
      '/access/rbac',
    )}${search}${hash}`;
  }

  return undefined;
}

export const AccessNavigationRedirects = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const redirectTarget = getAccessNavigationRedirect(location);

  return redirectTarget ? (
    <Navigate replace to={redirectTarget} />
  ) : (
    <>{children}</>
  );
};
